import React from 'react';
import {Outlet} from 'react-router-dom';

export const Templeton = () => <div>
  <Outlet/>
</div>;
